module.exports = __webpack_public_path__ + "static/media/ns.f170f47d.png";